import api from './api';

export interface Technician {
  id: number;
  user_id: number;
  first_name: string;
  last_name: string;
  email?: string;
  phone?: string;
  specialization?: string;
  certification_level?: string;
  experience_years?: number;
  hourly_rate?: number;
  availability_status?: string;
  skills?: string[];
  notes?: string;
  created_at?: string;
  updated_at?: string;
}

export interface TechniciansResponse {
  technicians: Technician[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

interface GetTechniciansParams {
  page?: number;
  limit?: number;
  search?: string;
  specialization?: string;
  availability_status?: string;
}

class TechniciansService {
  async getTechnicians(params: GetTechniciansParams = {}): Promise<{ data: Technician[]; total: number; page: number; limit: number; totalPages: number }> {
    try {
      console.log('Calling /admin/technicians with params:', params);
      const response = await api.get('/admin/technicians', { params });
      console.log('Raw API response:', response);
      console.log('Response data:', response.data);
      
      if (!response.data.success) {
        throw new Error(response.data.message || 'API returned success: false');
      }
      
      return {
        data: response.data.data.technicians,
        total: response.data.data.total,
        page: response.data.data.page,
        limit: response.data.data.limit,
        totalPages: response.data.data.totalPages
      };
    } catch (error: any) {
      console.error('Erreur lors de la récupération des techniciens:', error);
      if (error.response) {
        console.error('Error response status:', error.response.status);
        console.error('Error response data:', error.response.data);
      }
      throw error;
    }
  }

  async getTechnicianById(id: number): Promise<Technician> {
    try {
      const response = await api.get(`/technicians/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération du technicien ${id}:`, error);
      throw error;
    }
  }

  async createTechnician(technicianData: Partial<Technician>): Promise<Technician> {
    try {
      const response = await api.post('/technicians', technicianData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du technicien:', error);
      throw error;
    }
  }

  async updateTechnician(id: number, technicianData: Partial<Technician>): Promise<Technician> {
    try {
      const response = await api.put(`/technicians/${id}`, technicianData);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour du technicien ${id}:`, error);
      throw error;
    }
  }

  async deleteTechnician(id: number): Promise<void> {
    try {
      await api.delete(`/technicians/${id}`);
    } catch (error) {
      console.error(`Erreur lors de la suppression du technicien ${id}:`, error);
      throw error;
    }
  }

  async updateAvailabilityStatus(id: number, status: string): Promise<void> {
    try {
      await api.patch(`/admin/technicians/${id}/availability`, { availability_status: status });
    } catch (error) {
      console.error(`Erreur lors de la mise à jour du statut de disponibilité du technicien ${id}:`, error);
      throw error;
    }
  }
}

export const techniciansService = new TechniciansService();
export default techniciansService;